<template>
  <div>
    <div class="mt-4 px-5">
      <div class="flex justify-between mb-2" v-for="(model) in models">
        <p>{{ model.label }}</p>
        <div>
          <v-btn
            color="red"
            class="white--text mr-2"
            @click="actionModelData(model.key, 'Delete')"
            >Delete Data</v-btn
          >
          <v-btn
            :color="$vuetify.theme.currentTheme.primary"
            class="white--text"
            @click="actionModelData(model.key, 'Sync')"
            >Sync Model</v-btn
          >
        </div>
      </div>
    </div>
    <AlertPopUp
      :showConfirmationDialog="showActionDialog"
      :confirmationTitle="'Confirm'"
      :confirmationMessage="`Are you sure you want to ${this.selectedAction} the ${this.selectedKey} module data?`"
      :confirmationActionText="this.selectedAction"
      :confirmationActionColor="
        this.selectedAction === 'Delete' ? 'red' : 'blue'
      "
      :performAction="performAction"
      :cancel="cancel"
    />
  </div>
</template>
<script>
import AlertPopUp from "@/components/AlertPopUp";
export default {
  components: {
    AlertPopUp,
  },
  data() {
    return {
      models: [
        { label: "Company Model", key: "COMPANY_MODEL" },
        { label: "Customer Data/Model", key: "CUSTOMER_MODEL" },
        { label: "Employee Model", key: "USER_MODEL" },
        { label: "Inventory Model", key: "INVENTORY_MODEL" },
        { label: "Inventory History Model", key: "INVENTORY_HISTORY_MODEL" },
        { label: "Partner Model", key: "PARTNER_MODEL" },
        {label: "Lead/Product Model Data",key:"LEAD_MODEL"},
        {label: "Team Model Data",key:"TEAM_MODEL"},
        {label: "Branch Model Data",key:"BRANCH_MODEL"},
        {
          label: "Employee/User Inventory Model",
          key: "INVENTORY_HOLD_BY_USER",
        },
        { label: "Inventory Request", key: "INVENTORY_REQUEST_MODEL" },
        { label: "Notification Data", key: "NOTIFICATION_MODEL" },
        { label: "Product Mapping Data", key: "PRODUCT_MAPPING_MODEL" },
        { label: "Spare Part Status/Data", key: "SPARE_PART_MAPPING_MODEL" },
        { label: "Collection Case Data", key: "CASE_MODEL" },
        { label: "Collection Task Data", key: "CASE_TASK_MODEL" },
        { label: "Employee Leave Quota", key: "EMPLOYEE_LEAVE_QUOTA_MODEL" },
        { label: "Employee Leave", key: "LEAVE_REQUEST_MODEL" },
        { label: "Attendance Data", key: "ATTENDANCE_MODEL" },
      ],
      showActionDialog: false,
      selectedKey: "",
      selectedAction: "",
    };
  },
  methods: {
    actionModelData(key, action) {
      this.selectedKey = key;
      this.selectedAction = action;
      this.showActionDialog = true;
    },
    performAction() {
      try {
        let url =
          this.selectedAction === "Delete"
            ? "/workforce/org/drop/model"
            : "/workforce/org/sync/model";

        this.$axios.post(
          url,
          {
            modelId: this.selectedKey,
          },
        );
        if (this.selectedAction === "Delete") {
          this.$toast.success(
            `Module ${this.selectedKey} data deleted successfully`
          );
        } else if (this.selectedAction === "Sync") {
          this.$toast.success(
            `Module ${this.selectedKey} data synced successfully`
          );
        }
        this.cancel();
      } catch (error) {
        console.log(error);
        this.$toast.error(`Error ${error.status}: ${error.message}`);
      }
    },
    cancel() {
      this.showActionDialog = false;
    },
  },
};
</script>
<style></style>
